module.exports = __webpack_public_path__ + "img/left@2x.a4fc7e67.png";